import React, { useCallback, useContext } from 'react';
import { useProviderHelpers } from './ProviderHelpers';

const Context = React.createContext();

export const SmartDocCopyProvider = ({ children }) => {
    const { data, execute, clearData } = useProviderHelpers();

    const copyMappingsBetweenFranchise = useCallback(async (payload) => {
        await execute({
            scope: 'copyMappingsBetweenFranchise',
            url: 'SmartDoc/CopyMappingsBetweenFranchise',
            method: 'POST',
            payload,
            secure: true,
        });
    }, [execute]);

    const value = {
        data,
        clearData,
        copyMappingsBetweenFranchise,
    };

    return (
        <Context.Provider value={value}>
            {children}
        </Context.Provider>
    );
};

export const useSmartDocCopyStore = () => useContext(Context);